import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";

function Support() {

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  }, []);

  return (
    <div className="page container">

      <Helmet>
        <title>24/7 Support | realgeneric shop</title>
        <meta
          name="description"
          content="Realgeneric shop offers round-the-clock customer support for orders, delivery tracking, payments, and general queries."
        />
        <link rel="canonical" href="https://realgenericshop.com/support" />
      </Helmet>

      <h1>24/7 Service – Always Here for Your Health Needs</h1>

      <p>
        At <b>Realgeneric shop</b>, your health and convenience are our priority.
        That’s why we provide 24/7 customer support. Our team assists with
        order placement, payment issues, delivery tracking, and general enquiries.
      </p>

      <h3>Why Trust Realgeneric shop?</h3>

      <p>
        At Realgeneric shop, service is not just about support — it’s about
        protection, privacy, and reliability.
      </p>

      <ul>
        <li>Ensures uninterrupted access to essential medicines</li>
        <li>Round-the-clock assistance for orders, delivery, and payments</li>
        <li>Quick response via email, chat, and phone support</li>
        <li>Help available for tracking, replacements, and queries</li>
        <li>Support for customers across different time zones worldwide</li>
      </ul>

      <h3>How Our 24/7 Service Works</h3>

      <p>
        Whether you are in the US or anywhere else globally, our team is always ready to assist.
        You can contact us for:
      </p>

      <ul>
        <li>Order placement and confirmations</li>
        <li>Tracking and delivery updates</li>
        <li>General queries about medicines and availability</li>
      </ul>

      <h3>Contact Us Anytime</h3>

      <p>
        While we do not provide medical advice, you may contact us anytime for order-related help.
      </p>

      <p>
        International Call/Text: <a href="tel:+447471300624">+44 7471 300624</a>
      </p>

      {/* CHANGE: plain text ko mailto: link me convert kiya - tap karne par mail app khulega */}
      <p>
        Email: <a href="mailto:support@realgenericshop.com">support@realgenericshop.com</a>
      </p>

      <h3>FAQs</h3>

      <h4>Is Realgeneric shop support available 24/7?</h4>
      <p>
        Yes. Our support team is available round-the-clock to help with orders,
        payments, tracking, and delivery queries.
      </p>

      <h4>How can I contact customer support?</h4>
      <p>
        You can reach us anytime via email, chat, or phone for prompt assistance.
      </p>

      <h4>Do you provide medical advice in 24/7 support?</h4>
      <p>
        No. Our support team assists only with orders, shipping, and general queries.
        For medical advice, consult a licensed practitioner.
      </p>

      <h4>What if I face an issue at night?</h4>
      <p>
        Our 24/7 support ensures assistance across all time zones without delay.
      </p>

    </div>
  );
}

export default Support;
